import type { SVGProps } from 'react';
const SvgDynamicFeed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#dynamic_feed_svg__a)">
      <path d="M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8Z" />
      <path d="M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 8h-8V7h8v4ZM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7Z" />
    </g>
    <defs>
      <clipPath id="dynamic_feed_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDynamicFeed;
